export interface Volume {
  title: string
  items: string[]
  border: string
}

export const volumes: Volume[] = [
  {
    title: 'Volumen 1 — Captura y Control de la Información™',
    items: [
      'Creás un punto único donde colocás toda la información nueva',
      'Dejás de intentar procesar todo en el momento',
      'Registrás sin analizar: fecha, fuente, tema',
      'La información queda reunida en un solo lugar',
    ],
    border: 'border-blue-400/30',
  },
  {
    title: 'Volumen 2 — Organización y Priorización de la Información™',
    items: [
      'Ordenás todo lo que acumulaste por categorías claras',
      'Definís qué revisar, qué conservar, qué dejar pendiente y qué descartar desde el punto de vista organizativo',
      'Ves de un vistazo todo lo que ingresa',
      'Sabés exactamente dónde buscar cada cosa',
    ],
    border: 'border-green-400/30',
  },
  {
    title: 'Volumen 3 — Gestión y Mantenimiento de la Información™',
    items: [
      'Gestionás la información pendiente sin horas de trabajo',
      'Creás una rutina simple que mantiene el orden',
      'Evitás volver al caos cuando la información sigue llegando',
      'El sistema puede mantenerse con una rutina simple',
    ],
    border: 'border-amber-400/30',
  },
]

export const included: string[] = [
  'Punto de captura listo para usar desde hoy',
  'Cronograma de implementación de 14 días',
  'Tablas y checklists imprimibles',
  'Rutina de mantenimiento de 10 minutos por día',
]

export interface Bonus {
  number: string
  title: string
  details: string[]
  value: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Bandeja Única de Información™',
    details: [
      'Tabla y punto de captura central para que nada se pierda',
      'Implementación en 10 minutos',
      'Un solo lugar al que va todo lo que llega',
    ],
    value: '$12.000',
  },
  {
    number: '02',
    title: 'Checklist Anti-Saturación Informativa™',
    details: [
      'Preguntas rápidas para decidir qué hacer con cada cosa que llega',
      'Semáforo simple: verde, amarillo, rojo',
      'Menos vueltas y menos culpa en cada decisión',
    ],
    value: '$10.000',
  },
  {
    number: '03',
    title: 'Mapa Rápido de Fuentes y Canales™',
    details: [
      'Identificás de dónde viene el ruido',
      'Ordenás tus canales de información',
      'Menos interrupciones durante el día',
    ],
    value: '$11.000',
  },
  {
    number: '04',
    title: 'Rutina de 10 Minutos para Ordenar Pendientes™',
    details: [
      'Avanzás sobre lo acumulado sin dedicar horas',
      'Bloques simples y accionables',
      'Sabés siempre cuál es el próximo paso',
    ],
    value: '$9.000',
  },
  {
    number: '05',
    title: 'Guiones para Recibir Información sin Abrumarte™',
    details: [
      'Frases listas para responder mensajes, audios y consejos',
      'Dejás de sentirte obligada a procesarlo todo ahora',
      'Cuidás el vínculo sin cargarte de más',
    ],
    value: '$10.000',
  },
]
